export enum CollectionType {
  Group = 1,
  TIN = 2,
  Manual = 3,
  MultipleTIN = 4,
  MultipleGroupId = 5
}